import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getExperimentsAttributesQueryKey = () => QueryClientHelper.makeQueryKey('/rest/experiments/attributes');
//# sourceMappingURL=getExperimentsAttributesQueryKey.js.map